import { fetchWrapper } from '@/_helpers';

const BASE_URL = 'places/places-public';

export const placesSearchApi = {
    getCampuses: () => fetchWrapper.get('places/campus'),
    resolveMapIntent: (query, lat, lng) => {
        return fetchWrapper.post('places/map-intent', { query, lat, lng });
    },
    searchPlaces: ({
        query,
        lat,
        lng,
        geocodedLat,
        geocodedLng,
        radius,
        minPrice,
        maxPrice,
        limit,
        placeTypes,
        genericCampus,
    } = {}) => {
        const params = new URLSearchParams();
        if (query) params.append('query', query);
        if (lat != null) params.append('lat', lat);
        if (lng != null) params.append('lng', lng);
        if (geocodedLat != null) params.append('geocodedLat', geocodedLat);
        if (geocodedLng != null) params.append('geocodedLng', geocodedLng);
        if (radius) params.append('radius', radius);
        if (minPrice != null) params.append('minPrice', minPrice);
        if (maxPrice != null) params.append('maxPrice', maxPrice);
        if (limit) params.append('limit', limit);
        if (placeTypes) params.append('placeTypes', placeTypes);
        if (genericCampus) params.append('genericCampus', genericCampus);
        const queryString = params.toString();
        return fetchWrapper.get(`${BASE_URL}/search${queryString ? `?${queryString}` : ''}`);
    },
    getPlaceDetails: (placeId) => {
        return fetchWrapper.get(`${BASE_URL}/details/${encodeURIComponent(placeId)}`);
    },
};
